import styled from 'styled-components';

import { Typography } from '@seuk/design-system/atoms';

import type { CategoryLinkProps } from './category-link';
import { CategoryLink } from './category-link';

const Title = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;

const Links = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1rem;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

interface Category {
  label: string;
  name: string;
  childCategories: Category[];
}

export interface CategoriesListProps {
  categories: Category[];
  onCategoryClick: CategoryLinkProps['onClick'];
}

export const CategoriesList = (props: CategoriesListProps) => {
  return (
    <div>
      <Title>
        <Typography variant="h2">Questions and answers</Typography>
      </Title>
      <Links>
        {props.categories.map((category) => (
          <CategoryLink
            key={category.name}
            label={category.label}
            name={category.name}
            subcategories={category.childCategories.map((c) => c.label)}
            onClick={props.onCategoryClick}
          />
        ))}
      </Links>
    </div>
  );
};
